
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code3 } from "./data";

export default defineComponent({
  name: "border-card",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code3
    };
  }
});
